(() => {

  const init = (scope = document) => {

    scope.querySelectorAll('[data-aurora-editorial]').forEach(root => {

      if (root.dataset.initialized) return;

      root.dataset.initialized = 'true';

      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {

        const target = document.getElementById(link.hash.slice(1));

        if (!target || !root.contains(target)) return;

        event.preventDefault();

        target.scrollIntoView({behavior: behavior(), block: 'start', inline: 'nearest'});

        target.setAttribute('tabindex', '-1');

        target.focus({preventScroll: true});

        history.replaceState(null, '', link.hash);

      }));

    });

  };

  init();

  document.addEventListener('shopify:section:load', event => init(event.target));

})();
